import React from 'react';
import { Bar } from '@ant-design/plots';
import { LabelImportant } from '@mui/icons-material';

const Mostdownloaded = (props) => {
  const data = []
  props?.totalTopDownload.forEach(element => {
    data.push({
      Email: element.position,
      Downloads: parseInt(element.downloads),
    })
  });

  if (data.length > 0) {
    let newData = data.map((item) => ({
      letter: item.Email,
      frequency: item.Downloads
    }));
    const config = {
      data: data,
      height: 230,
      xField: 'Email',
      yField: 'Downloads',
      sort: {
        reverse: true,
      },
      // label: {
      //   text: 'Downloads',
      // },
      axis: {
        x: {
          // This part is the configuration of the grid lines 
          // grid: true,  //Whether to show grid lines   
          // gridLineWidth: 2,  //gridline width   
          //This part is the configuration of the axis 
          line: false,  //Whether the axis is shown   
          lineLineWidth: 1,  //width of axis   
          lineStroke: '#666',  //axis Stroke   
          //This part is the configuration of the axis scale 
          tick: true,  //whether the scale is displayed   
          tickLineWidth: 2,  //width of scale line   
          tickLength: 2,  //gradeline length   
          tickStroke: '#666',  // tick-line colour   
          // This part is the configuration of the axis label 
          label: true,  //Whether the scale value is displayed   
          labelFontSize: 12,  // Scale value text size   
          // labelFill: '#009900',  //scale-valuefontcolor   
          labelFontWeight: 500,  // Scale value font thickness   
        },
        y: {

          // This part is the configuration of the grid lines 
          grid: true,  //Whether to show grid lines   
          gridLineWidth: 1,  //gridline width   
          //This part is the configuration of the axis 
          line: false,  //Whether the axis is shown   
          lineLineWidth: 0,  //width of axis   
          lineStroke: '#666',  //axis Stroke   
          //This part is the configuration of the axis scale 
          tick: false,  //whether the scale is displayed   
          tickLineWidth: 2,  //width of scale line   
          tickLength: 2,  //gradeline length   
          tickStroke: '#3366ff',  // tick-line colour   
          // This part is the configuration of the axis label 
          label: true,  //Whether the scale value is displayed   
          labelFontSize: 12,  // Scale value text size   
          // labelFill: '#009900',  //scale-valuefontcolor   
          labelFontWeight: 500,  // Scale value font thickness  
          gridLineDash: [0, 0]
        }
      },
      scrollbar: {
        type: 'vertical',
        style: {
          trackColor: '#F0FAFF',
          thumbColor: '#D7F2FF'
        },
        x: {
          ratio: 0.5,
          trackSize: 8,
          trackFillOpacity: 1,
          trackLineWidth: 1,
          trackFill: '#2CDDC7',
          trackStroke: '#2CDDC7',
          trackStrokeOpacity: 1,
          position: 'right',
          thumbStroke: '#D7F2FF',
          thumbFill: '#D7F2FF',
          thumbFillOpacity: 1,
        },
      },
      style: {
        showTitle: false,
        maxWidth: 15,
        minWidth: 15,
        fill: '#2CDDC7',
        radiusTopLeft: 10,
        radiusTopRight: 10,
        radiusBottomLeft: 10,
        radiusBottomRight: 10,
      },
    };
    return <Bar {...config} />;
  }
  // Fallback if no data
  return <div>No downloads data available.</div>;

};

export default Mostdownloaded;
